import { Map } from 'immutable';

import { aiGenerated } from './ai';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';

export function metaDescription({ channel, operation, preview, state }) {
  switch (operation) {
    case OPERATIONS[channel].META_DESCRIPTION.AI_GENERATED: {
      return aiGenerated({ attribute: ATTRIBUTE.META_DESCRIPTION, channel, preview, state });
    }

    case OPERATIONS[channel].META_DESCRIPTION.FIND_AND_REPLACE: {
      return {
        payload: Map({
          type: preview.getIn([ATTRIBUTE.META_DESCRIPTION, 'operation']),
          value: Map({
            find: preview.getIn([ATTRIBUTE.META_DESCRIPTION, FIND]),
            replace: preview.getIn([ATTRIBUTE.META_DESCRIPTION, REPLACE]),
          }),
        }),
      };
    }

    default: {
      return {
        payload: Map({
          type: preview.getIn([ATTRIBUTE.META_DESCRIPTION, 'operation']),
          value: preview.getIn([ATTRIBUTE.META_DESCRIPTION, VALUE], ''),
        }),
      };
    }
  }
}
